module.exports = __webpack_public_path__ + "static/about-bg-2c08d0b3a2385927354fe67e14bfc7fa.png";